import React from 'react'
import { MultiSelect } from "primereact/multiselect"
import { ToggleButton } from "primereact/togglebutton"

export type DynamicButtonListProps<T> =
  {
    primaryOptions      : T[]
    secondaryOptions?   : T[]
    vertical?           : boolean
  } & {
    value               : T | null
    onChange            : (_:T | null) => void | Promise<void>
    optionLabel         : (_:T) => string
    optionLabelKey      : (_:T) => string
  }

export const DynamicButtonList = <X,>(props: DynamicButtonListProps<X>) => {
  const hasOverlap = (item:X,array2:X[]) : boolean => {
    return array2.some(obj2 => props.optionLabelKey ? props.optionLabelKey(item) === props.optionLabelKey(obj2) : item === obj2)
  }

  const toggleSelection = (option:X) => {
    props.onChange(props.value && props.optionLabelKey(option) == props.optionLabelKey(props.value) ? null : option)
  }

  const handleMultiSelectChange = (selectedItems:string[]) => {
    if(props.secondaryOptions)
    {
      props.onChange(selectedItems.length ? props.secondaryOptions.find((x) => props.optionLabelKey(x) === selectedItems[0]) ?? null : null)
    }
  }

  return (
    <>
      <div className="d-flex flex-wrap justify-content-center">
        {props.primaryOptions.map(option =>
          <div key={props.optionLabelKey(option)}
              className="p-2"
              style={{ width:props.vertical ? '100%' : 'calc(50% - 1rem)' }}
          >
            <ToggleButton
              checked={!!props.value && props.optionLabelKey(props.value) === props.optionLabelKey(option)}
              offLabel={typeof option == 'string' ? option : props.optionLabel && ((x) => typeof x === 'string' ? x : '!ERROR!') (props.optionLabel(option))}
              onLabel={typeof option == 'string' ? option : props.optionLabel && ((x) => typeof x === 'string' ? x : '!ERROR!')(props.optionLabel(option))}
              onChange={() => toggleSelection(option)}
              className="w-100"
            />
          </div>
        )}
        {props.secondaryOptions && (
          <MultiSelect
            options={props.secondaryOptions.map((x) => ({ 'label':props.optionLabel(x),'value':props.optionLabelKey(x) }))}
            // optionLabel={props.optionLabel}
            value={props.value && !hasOverlap(props.value,props.primaryOptions) ? [props.optionLabelKey(props.value)] : []}
            onChange={(e) => handleMultiSelectChange(e.value)}
            display="chip"
            filter
            disabled={undefined}
            placeholder="more"
            max={undefined}
            selectionLimit={undefined}
            className="w-50"
          />
        )}
      </div>
    </>
  )
}

export default DynamicButtonList
